import {map, filter} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {BehaviorSubject, Observable} from 'rxjs';
import {PledgeCountyReport} from '../../../../../services/api.client';
import {PledgeReportForm} from '../../PledgeReportForm';

@Component({
    templateUrl: './PledgeByCountyComponent.html',
    standalone: false
})
export class PledgeByCountyComponent implements OnInit {

    @ViewChild('form')
    form: PledgeReportForm;

    tableHeaders: ITableHeader[] = [
        {text: 'State'},
        {text: 'County'},
        {text: 'Pledge Count'},
        {text: 'Pledge Amount'},
    ];

    private readonly _report$ = new BehaviorSubject<PledgeCountyReport[]>(null);

    report$: Observable<PledgeCountyReport[]> = this._report$.asObservable();

    rows: Observable<(string | number)[][]>;

    ngOnInit(): void {
        this.rows = this.report$.pipe(
            filter(report => !!report),
            map((report) => report.map((county) => [
                county.state,
                county.county,
                county.pledgeCount,
                '$' + county.pledgeTotal.toFixed(2)])),);
    }

    submitReport(): void {
        this.form.submitPledgeDemographicByCountyReport()?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
    }
}
